export default "__VITE_ASSET__BUkdn0jx__"